import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CharacterCounter from './pages/CharacterCounter';
import CaseConverter from './pages/CaseConverter';
import WhitespaceRemover from './pages/WhitespaceRemover';
import TextCompare from './pages/TextCompare';
import DuplicateRemover from './pages/DuplicateRemover';
import KoreanConverter from './pages/KoreanConverter';
import Base64Tool from './pages/Base64Tool';
import LineSorter from './pages/LineSorter';
import CharacterRemover from './pages/CharacterRemover';
import LoremIpsum from './pages/LoremIpsum';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/character-counter" element={<CharacterCounter />} />
        <Route path="/case-converter" element={<CaseConverter />} />
        <Route path="/whitespace-remover" element={<WhitespaceRemover />} />
        <Route path="/text-compare" element={<TextCompare />} />
        <Route path="/duplicate-remover" element={<DuplicateRemover />} />
        <Route path="/korean-converter" element={<KoreanConverter />} />
        <Route path="/base64" element={<Base64Tool />} />
        <Route path="/line-sorter" element={<LineSorter />} />
        <Route path="/character-remover" element={<CharacterRemover />} />
        <Route path="/lorem-ipsum" element={<LoremIpsum />} />
      </Routes>
    </Router>
  );
}

export default App;
